import { Sidebar } from '@rewind-ui/core'
import React, { useContext } from 'react'
import { HiOutlineXMark } from 'react-icons/hi2'
import { Link, useLocation } from 'react-router-dom'
import { AppContext } from '../../../modules/contexts/AppContexts'
import { FaUserLock } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from '../LanguageSwitcher'
import { TbHome, TbUserCircle, TbFileReport, TbListCheck, TbReportAnalytics } from 'react-icons/tb'

const SideNav = ({ navOpen, setNavOpen }) => {
    const location = useLocation().pathname
    const { userData, setStartAuth } = useContext(AppContext)
    const { t } = useTranslation('navbar')
    const user = userData?.user_data || {}
    const userIsIndividual = user.user_type === 'individual'
    const isAdmin = user.role === 'admin' || user.is_superuser

    return (
        <div className={`flex bg-white/80 backdrop-blur-sm focus:bg-white px-[10px] tablet:px-[5vw] pt-5 ${navOpen} h-[100vh] top-0 flex-col tablet:w-[40vw] w-[65vw] fixed ease-in duration-150 desktop:hidden`}>
            <div className="logo flex justify-between w-full gap-5">
                <Link to="/">
                    <img className='tablet:w-[22vw] desktop:w-[12vw] w-[45vw] bg-white object-cover' src="/logos/unido.jpeg" alt="UNIDO Logo" />
                </Link>

                <button onClick={() => setNavOpen('tablet:-left-[40vw] -left-[75vw]')}>
                    <HiOutlineXMark className='text-3xl' />
                </button>
            </div>

            <div className="flex flex-col gap-3 tablet:!ps-0 py-10 pb-5">
                <div className="mb-2">
                    <LanguageSwitcher />
                </div>
                
                <Sidebar className='w-full relative' color='light' shadow='none'>
                    <Sidebar.Nav>
                        <Sidebar.Nav.Section>
                            <Sidebar.Nav.Section.Title className='text-green-600 font-medium'>{t('navigation')}</Sidebar.Nav.Section.Title>
                            <Link to="/">
                                <Sidebar.Nav.Section.Item 
                                    className={`hover:bg-emerald-50 transition-colors duration-200 ${location === '/' ? 'text-green_s4' : 'text-gray-500'}`}
                                    icon={<TbHome className={location === '/' ? 'text-green_s4' : 'text-emerald-600'} />}
                                    label={t('home')}
                                />
                            </Link>
                            
                            <Link to="/profile">
                                <Sidebar.Nav.Section.Item 
                                    className={`hover:bg-emerald-50 transition-colors duration-200 ${location === '/profile' ? 'text-green_s4' : 'text-gray-500'}`}
                                    icon={<TbUserCircle className={location === '/profile' ? 'text-green_s4' : 'text-emerald-600'} />}
                                    label="Profile" 
                                />
                            </Link>

                            {!userIsIndividual && (
                                <Link to="/vetting">
                                    <Sidebar.Nav.Section.Item 
                                        className={`hover:bg-emerald-50 transition-colors duration-200 ${location === '/vetting' ? 'text-green_s4' : 'text-gray-500'}`}
                                        icon={<TbListCheck className={location === '/vetting' ? 'text-green_s4' : 'text-emerald-600'} />}
                                        label={t('assessment')}
                                    />
                                </Link>
                            )}

                            {isAdmin && (
                                <Link to="/report">
                                    <Sidebar.Nav.Section.Item 
                                        className={`hover:bg-emerald-50 transition-colors duration-200 ${location === '/report' ? 'text-green_s4' : 'text-gray-500'}`}
                                        icon={<TbFileReport className={location === '/report' ? 'text-green_s4' : 'text-emerald-600'} />}
                                        label={t('report')}
                                    />
                                </Link>
                            )}
                        </Sidebar.Nav.Section>

                        {isAdmin && (
                            <Sidebar.Nav.Section>
                                <Sidebar.Nav.Section.Title className='text-green-600 font-medium'>{t('admin')}</Sidebar.Nav.Section.Title>
                                <Link to="/vetting/admin/reports">
                                    <Sidebar.Nav.Section.Item 
                                        className={`hover:bg-emerald-50 transition-colors duration-200 ${location.startsWith('/vetting/admin/reports') ? 'text-green_s4' : 'text-gray-500'}`}
                                        icon={<TbReportAnalytics className={location.startsWith('/vetting/admin/reports') ? 'text-green_s4' : 'text-emerald-600'} />}
                                        label={t('assessment_report')}
                                    />
                                </Link>
                            </Sidebar.Nav.Section>
                        )}

                        {!userData && (
                            <Sidebar.Nav.Section>
                                <Sidebar.Nav.Section.Item 
                                    onClick={() => setStartAuth(true)} 
                                    label={t('login')} 
                                    icon={<FaUserLock />} 
                                    className='bg-gray-900 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors duration-200' 
                                />
                                <div className="w-full flex flex-col pt-3">
                                    <span className='text-sm text-gray-500'>
                                        {t('loginMessage')}
                                    </span>
                                </div>
                            </Sidebar.Nav.Section>
                        )}
                    </Sidebar.Nav>
                </Sidebar>
                
                <div className="mt-auto mb-5 pt-5 border-t border-gray-200">
                    <Link to="/" className="flex items-center gap-2 hover:bg-gray-100 p-2 rounded transition-colors duration-200">
                        <img className='tablet:w-[20vw] desktop:w-[10vw] w-[40vw] object-cover' src="/logos/logo_base.webp" alt="" />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default SideNav